// Experiments — which GrowthBook flags and experiments this user is evaluating into.
//
// Was a collapsed accordion where every feature printed two to four labelled lines,
// so twenty flags was an eighty-line block nobody scrolled. One row each now: the
// feature id, what kind it is and which group they landed in underneath, and the
// evaluated value on the trailing edge — which is the thing you opened this for.
//
// Still a class component, because `loadFeatures()` in `componentDidMount` is the only
// thing it does and rewriting that as a hook is not what this change is.
import React from 'react';
import { Box, Typography } from '../../../ui/core';
import { scrollY } from '../../../ui/styles';
import { InfoIcon } from '../../../ui/icons';
import { SectionCard, EmptyRows } from '../../../pages/DriverProfile/components';
import { Row, TrailingMeta, Meta } from '../../../pages/UserProfile/parts';

/** What the flag evaluated to, as one line — `undefined` prints as an em dash, not "undefined". */
const evaluatedValue = (data) => {
  const value = data.experiment ? data.experimentResult?.value : data.value;
  return value === undefined ? '—' : JSON.stringify(value);
};

/** "Feature flag · on", "Experiment · variant-b" — the two facts under the name. */
const describe = (data) => {
  if (!data.experiment) return `Feature flag · ${data.on ? 'on' : 'off'}`;
  if (!data.experimentResult) return 'Experiment';
  return `Experiment · ${data.experimentResult.inExperiment ? data.experimentResult.name : 'not included'}`;
};

export default class ExperimentsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { features: null };
  }

  componentDidMount() {
    const growthbook = this.props.growthbook;

    growthbook.loadFeatures().then(() => {
      let features = {};
      Object.keys(growthbook.getFeatures()).forEach((featureId) => {
        features[featureId] = growthbook.evalFeature(featureId);
      });

      this.setState({ features });
    });
  }

  render() {
    const { features } = this.state;
    const ids = features ? Object.keys(features) : [];

    return (
      <SectionCard
        title="Experiments"
        icon={<InfoIcon sx={{ fontSize: 17, color: 'text.secondary', flexShrink: 0 }} />}
        meta={
          features ? (
            <TrailingMeta>
              <Meta>{ids.length} evaluated</Meta>
            </TrailingMeta>
          ) : null
        }
      >
        {!features && <EmptyRows>Loading…</EmptyRows>}
        {features && ids.length === 0 && <EmptyRows>No features are being evaluated for this user.</EmptyRows>}
        {features && ids.length > 0 && (
          <Box sx={{ maxHeight: 300, ...scrollY }}>
            {ids.map((id, i) => (
              <Row
                key={id}
                first={i === 0}
                label={id}
                meta={describe(features[id])}
                right={
                  <Typography
                    sx={{ fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
                    title={evaluatedValue(features[id])}
                  >
                    {evaluatedValue(features[id])}
                  </Typography>
                }
              />
            ))}
          </Box>
        )}
      </SectionCard>
    );
  }
}
